import axios from 'axios';
import { PAGING_DEFAULT } from '../constants/constants';
import { utils } from '../functions';
import { addParamsToQueryString } from '../functions/utils';
import { IParamsRequest } from '../interfaces/IAction';
import { IApiResponse } from '../interfaces/IApiResponse';
import RestClient from './restClient';
import urls from './urls';
import { generateParams } from './userApi';

class EventApi {
  static getEventSearch(params: IParamsRequest): Promise<IApiResponse> {
    const queryString = generateParams({
      ...params,
    });
    const url = `${urls.GET_EVENT_SEARCH}${queryString ? '?' : ''}${queryString}`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getClubSearch(params: IParamsRequest): Promise<IApiResponse> {
    const queryString = generateParams({
      ...params,
    });
    const url = `${urls.GET_CLUB_SEARCH}${queryString ? '?' : ''}${queryString}`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getDetailClub(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.GET_DETAIL_CLUB.replace('{ID}', params.clubId || '-1');
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getPhotoDetailClub(params: IParamsRequest): Promise<IApiResponse> {
    const url = addParamsToQueryString(urls.GET_PHOTO_DETAIL_CLUB.replace('{ID}', params.clubId || '-1'), params);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getEventCategory(): Promise<IApiResponse> {
    const url = urls.GET_EVENT_CATEGORY;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getClubCategory(): Promise<IApiResponse> {
    const url = urls.GET_CLUB_CATEGORY;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getUserEvents(params: IParamsRequest): Promise<IApiResponse> {
    const queryString = generateParams({
      ...params,
      page: (params && params.page) || 1,
      size: (params && params.pageSize) || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
    });
    const url = `${urls.GET_USER_EVENT}${queryString ? '?' : ''}${queryString}`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getEventOfUser(params: IParamsRequest): Promise<IApiResponse> {
    let url = urls.GET_MY_USER_EVENT;
    if (params.isClubEvent) {
      url = urls.GET_USER_CLUB_EVENT;
    }
    url = `${url.replace('{EventID}', `${params.ID || '-1'}`)}`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getUserEventInterest(params: IParamsRequest): Promise<IApiResponse> {
    const queryString = generateParams({
      ...params,
      size: (params && params.pageSize) || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
    });
    const url = `${urls.GET_USER_INTEREST_EVENT.replace('{EventID}', `${params.ID || '-1'}`)}${queryString ? '?' : ''}${queryString}`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getEventInterest(params: IParamsRequest): Promise<IApiResponse> {
    const queryString = generateParams({
      ...params,
      size: (params && params.pageSize) || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
    });
    const url = `${urls.GET_EVENT_INTEREST_LIST.replace('{ID}', `${params.ID || '-1'}`)}${queryString ? '?' : ''}${queryString}`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static deleteEventInterest(id: string): Promise<IApiResponse> {
    const url = `${urls.DELETE_EVENT_INTEREST.replace('{ID}', id)}`;
    return axios.patch(url, null, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getEventComment(params: IParamsRequest): Promise<IApiResponse> {
    const queryString = generateParams({
      size: (params && params.pageSize) || 10,
      page: (params && params.page) || 1,
    });
    const url = `${urls.GET_EVENT_COMMENT.replace('{ID}', `${params.ID || '-1'}`)}${queryString ? '?' : ''}${queryString}`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getEventClub(params: IParamsRequest): Promise<IApiResponse> {
    const queryString = generateParams({
      ...params,
      Size: (params && params.pageSize) || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
    });
    const url = `${urls.GET_EVENT_CLUB.replace('{ID}', `${params.ID || '-1'}`)}${queryString ? '?' : ''}${queryString}`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getEventDetail(params: IParamsRequest): Promise<IApiResponse> {
    let url = `${urls.GET_EVENT_DETAIL.replace('{ID}', `${params.ID || '-1'}`)}`;
    if (params && utils.hasOwnProperty(params, 'preview') && params.preview !== undefined) {
      url += `?preview=${params.preview}`;
    }
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateEvent(params: IParamsRequest, clubId?: any, additionalDateHelds?: string[]): Promise<IApiResponse> {
    let url = urls.POST_CREATE_EVENT;
    if (clubId) {
      url = urls.POST_CREATE_USER_CLUB_EVENT.replace('{ClubID}', clubId);
    }
    const gernerateParams = {
      Detail: params,
      AdditionalDateHelds: additionalDateHelds || [],
    };
    return axios.post(url, gernerateParams, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateEventInterest(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.POST_CREATE_EVENT_INTEREST.replace('{ID}', `${params.id || '-1'}`);
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static createEventInterestInvite(id: string): Promise<IApiResponse> {
    const url = urls.CREATE_EVENT_INTEREST_INVITE.replace('{ID}', id);
    return axios.post(url, null, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateEventComment(body: any, params: IParamsRequest): Promise<IApiResponse> {
    // const url = urls.POST_CREATE_EVENT_COMMENT.replace('{ID}', params.ID || '-1');
    // return axios.post(url, body, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
    const url = urls.POST_CREATE_EVENT_COMMENT.replace('{ID}', `${params.ID || '-1'}`);
    let isFormData: boolean = false;
    if (body.MessageContentType !== 'Text' && body.MessageContentType !== 'Giphy') {
      isFormData = true;
    }
    const restClient = new RestClient();
    restClient.setBaseUrl(urls.BASE_RHPURL);
    // @ts-ignore
    return restClient.execute(url, 'POST', body, false, false, false, isFormData).then(res => res);
    // return axios.post(url, params.body, {baseURL: urls.BASE_RHPURL, headers});
  }

  static patchDeleteEvent(params: { eventId: string; clubId?: any }): Promise<IApiResponse> {
    const generateParam = {
      ListID: [params.eventId],
    };
    let url = urls.PATCH_DELETE_MY_EVENT;
    if (params.clubId) {
      url = urls.PATCH_DELETE_USER_CLUB_EVENT.replace('{ClubID}', params.clubId);
    }

    return axios.patch(url, generateParam, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static patchDeleteInterest(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.PATCH_DELETE_EVENT_INTEREST.replace('{ID}', `${params.id || '-1'}`);
    return axios.patch(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static patchDeleteUserInterest(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.PATCH_DELETE_USER_EVENT_INTEREST.replace('{EventID}', `${params.ID || '-1'}`);
    return axios.patch(url, { ListID: params.ListID }, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getEventPopularCount(params: IParamsRequest): Promise<IApiResponse> {
    const url = addParamsToQueryString(urls.GET_EVENT_POPULAR_COUNT, params);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getClubCount(params: IParamsRequest): Promise<IApiResponse> {
    const url = addParamsToQueryString(urls.GET_CLUB_COUNT, params);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static patchUpdateMyEvent(params: IParamsRequest, clubId?: any): Promise<IApiResponse> {
    let url = urls.GET_MY_USER_EVENT;
    if (clubId) {
      url = urls.GET_USER_CLUB_EVENT;
    }
    url = url.replace('{EventID}', params.EventID || '-1');
    return axios.patch(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getTimezone(): Promise<IApiResponse> {
    return axios.get(urls.GET_TIMEZONE, {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
    });
  }

  static getBanner(): Promise<IApiResponse> {
    return axios.get(urls.GET_EVENT_BANNER, {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
    });
  }

  static uploadOwnBanner(body: any): Promise<IApiResponse> {
    const url = urls.POST_UPLOAD_BANNER;
    const restClient = new RestClient();
    restClient.setBaseUrl(urls.BASE_RHPURL);

    return (restClient as any).execute(url, 'POST', body, false, false, false, true).then((res: IApiResponse) => res);
    // return axios.post(urls.POST_UPLOAD_BANNER, body, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false , 'Content-Type': 'multipart/form-data', accept:'application/json'} });
  }

  static getClubDetail(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.GET_CLUB_DETAIL.replace('{ID}', `${params.id || '-1'}`);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getClubEvents(params: IParamsRequest): Promise<IApiResponse> {
    const url = `${urls.GET_CLUB_EVENT.replace('{ID}', `${params.id || '-1'}`)}?Size=${params.size}&Page=${params.page}`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static patchUserEventInterestTicket(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.PATCH_UPDATE_USER_EVENT_TICKET.replace('{EventID}', params.EventID || '-1').replace(
      '{InterestID}',
      params.InterestID || '-1'
    );
    return axios.patch(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static patchUserEventInterestGroupChat(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.PATCH_UPDATE_USER_EVENT_GROUP_CHAT.replace('{EventID}', params.EventID || '-1').replace(
      '{InterestID}',
      params.InterestID || '-1'
    );
    return axios.patch(
      url,
      { IsEnabled: params.IsEnabled },
      {
        baseURL: urls.BASE_RHPURL,
        headers: { isAnonymous: false },
      }
    );
  }

  static deleteAllUserEventInterestGroupChat(eventID: string): Promise<IApiResponse> {
    const url = urls.DELETE_ALL_USER_EVENT_GROUP_CHAT.replace('{EventID}', eventID);
    return axios.delete(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateGroupChat(params: any): Promise<IApiResponse> {
    const url = urls.POST_CREATE_GROUP_CHAT;
    return axios.post(url, params, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } });
  }

  static getSearchGroupChat(params: any): Promise<IApiResponse> {
    const url = urls.GET_SEARCH_GROUP_CHAT.replace('{refObjId}', params.refObjId).replace('{refObjType}', params.refObjType);
    return axios.get(url, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } });
  }

  static patchUpdateGroupChat(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.PATCH_UPDATE_GROUP_CHAT.replace('{roomJid}', encodeURIComponent(params.roomJid || '-1'));
    return axios.patch(url, params.body, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } });
  }

  static postAddAMemberFromGroupChat(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.POST_ADD_MEMBER_GROUP_CHAT.replace('{roomJid}', encodeURIComponent(params.roomJid || '-1')).replace(
      '{userId}',
      `${params.userId}` || '-1'
    );
    return axios.post(url, {}, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } });
  }

  static postRemoveAMemberFromGroupChat(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.POST_LEAVE_MEMBER_GROUP_CHAT.replace('{roomJid}', encodeURIComponent(params.roomJid || '-1')).replace(
      '{userId}',
      `${params.userId}` || '-1'
    );
    return axios.post(url, {}, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } });
  }

  static postEndGroupChat(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.POST_END_GROUP_CHAT.replace('{roomJid}', encodeURIComponent(params.roomJid || '-1'));
    return axios.post(url, {}, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } });
  }

  static postLeaveGroupChat(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.POST_LEAVE_GROUP_SUCCESS.replace('{roomJid}', encodeURIComponent(params.roomJid || '-1'));
    const data = { isHistoryDeletion: params.isHistoryDeletion !== undefined ? params.isHistoryDeletion : true };
    return axios.post(url, data, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } });
  }

  static getPrivateGroupChat(params: IParamsRequest): Promise<IApiResponse> {
    let url = urls.GET_PRIVATE_GROUP_CHAT.replace('{roomJid}', encodeURIComponent(params.roomJid || '-1'));
    if (params.shareToken) {
      url += `?shareToken=${params.shareToken}`;
    }
    return axios.get(url, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } });
  }

  static postAcceptRules(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.POST_ACCEPT_RULES.replace('{roomJid}', encodeURIComponent(params.roomJid || '-1'));
    return axios.post(url, {}, { baseURL: urls.BASE_URL, headers: { isAnonymous: false } });
  }

  static deleteEventInterestByOwner(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.DELETE_EVENT_INTEREST_BY_OWNER.replace('{EventID}', params.eventId || '-1').replace(
      '{InterestID}',
      params.interestId || '-1'
    );
    return axios.delete(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postSearchUserEventInterests(params: IParamsRequest): Promise<IApiResponse> {
    const data = {
      EventID: params.eventId,
      MemberTypes: params.memberTypes,
      Username: params.username,
      GroupChatStatus: params.groupChatStatus,
      Size: params.size || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
      Page: params.page || 1,
    };
    const url = `${urls.POST_USER_INTEREST_EVENT.replace('{EventID}', params.eventId || '-1')}`;
    return axios.post(url, data, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateEventVideo(params: IParamsRequest): Promise<IApiResponse> {
    return axios.post(urls.POST_CREATE_EVENT_VIDEO, params, {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
      timeout: 99999999,
    });
  }

  static getSuggestedUsers(params: {
    eventId: string;
    pageSize?: number;
    page?: number;
    memberType?: number;
    ageMax?: number;
    ageMin?: number;
  }) {
    let paramsQuery = {
      Page: params?.page || 1,
      Size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
      MemberType: -1,
      AgeMax: -1,
      AgeMin: -1,
    };
    if (params.memberType) {
      paramsQuery['MemberType'] = params.memberType;
    }
    if (paramsQuery['MemberType'] === -1) {
      delete (paramsQuery as { MemberType?: number }).MemberType;
    }
    if (params.ageMax) {
      paramsQuery['AgeMax'] = params.ageMax;
    } else {
      delete (paramsQuery as { AgeMax?: number }).AgeMax;
    }
    if (params.ageMin) {
      paramsQuery['AgeMin'] = params.ageMin;
    } else {
      delete (paramsQuery as { AgeMin?: number }).AgeMin;
    }
    const queryString = generateParams(paramsQuery);
    const url = `${urls.GET_EVENT_SUGGESTED_MEMBERS.replace('{EventID}', params.eventId)}${queryString ? '?' : ''}${queryString}`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getUserClubEventSuggestedUsers(params: {
    eventId: string;
    pageSize?: number;
    page?: number;
    memberType?: number;
    ageMax?: number;
    ageMin?: number;
  }) {
    let paramsQuery = {
      Page: params?.page || 1,
      Size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
      MemberType: -1,
      AgeMax: -1,
      AgeMin: -1,
    };
    if (params.memberType) {
      paramsQuery['MemberType'] = params.memberType;
    }
    if (paramsQuery['MemberType'] === -1) {
      delete (paramsQuery as { MemberType?: number }).MemberType;
    }
    if (params.ageMax) {
      paramsQuery['AgeMax'] = params.ageMax;
    } else {
      delete (paramsQuery as { AgeMax?: number }).AgeMax;
    }
    if (params.ageMin) {
      paramsQuery['AgeMin'] = params.ageMin;
    } else {
      delete (paramsQuery as { AgeMin?: number }).AgeMin;
    }
    const queryString = generateParams(paramsQuery);
    const url = `${urls.GET_USER_CLUB_EVENT_SUGGESTED_MEMBERS.replace('{EventID}', params.eventId)}${queryString ? '?' : ''}${queryString}`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
}

export default EventApi;
